var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "-1 -3 27 29",
    fill: "#697582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19.5A2.503 2.503 0 0 1 0 17V7c0-1.379 1.121-2.5 2.5-2.5h19C22.878 4.5 24 5.621 24 7v10c0 1.378-1.122 2.5-2.5 2.5h-19zm0-14C1.673 5.5 1 6.173 1 7v10c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5V7c0-.827-.673-1.5-1.5-1.5h-19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.75a.5.5 0 0 1-.5-.5v-6.5a.5.5 0 0 1 1 0v6.5a.5.5 0 0 1-.5.5zM18.5 15.75a.5.5 0 0 1-.5-.5v-6.5a.5.5 0 0 1 1 0v6.5a.5.5 0 0 1-.5.5zM7.5 13.25a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5zM12.5 13.25a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5zM14.5 13.25a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5zM9.5 13.25a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5zM16.5 13.25a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5zM7.5 15.75a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 1 0v.5a.5.5 0 0 1-.5.5zM9.5 15.75a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 1 0v.5a.5.5 0 0 1-.5.5zM12.5 15.75a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 1 0v.5a.5.5 0 0 1-.5.5zM14.5 15.75a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 1 0v.5a.5.5 0 0 1-.5.5zM16.5 15.75a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 1 0v.5a.5.5 0 0 1-.5.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarcode);
export default __webpack_public_path__ + "static/media/icon_barcode.d69e1eca7e85ee19f37a8da957134da7.svg";
export { ForwardRef as ReactComponent };